import { useEffect, useRef } from "react";
import { motion, useInView, useAnimation } from "framer-motion";
import { useTranslation } from "react-i18next";
import PlusTax from "./PlusTax";

const features = [
  {
    name: "birthdayBoyPawtieTitle",
    description: "birthdayBoyPawtieDescription",
  },
  {
    name: "birthdaySilverPawtieTitle",
    description: "birthdaySilverPawtieDescription",
  },
  {
    name: "birthdayGoldPawtieTitle",
    description: "birthdayGoldPawtieDescription",
  },
];

export default function Example() {
  const { t } = useTranslation();
  const container = useRef(null);
  const isInView = useInView(container);
  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start({
        x: 0,
        transition: {
          type: "spring",
          duration: 2,
          bounce: 0.2,
        },
      });
    }
  }, [isInView, animation]);

  return (
    <div className="bg-custom-rose">
      <section aria-labelledby="features-heading" className="relative">
        <div className="aspect-w-3 aspect-h-2 overflow-hidden sm:aspect-w-5 lg:aspect-none lg:absolute lg:h-full lg:w-1/2 right-0 lg:left-auto lg:pl-4 xl:pl-16">
          <img
            src="/assets/img/IMG-20240803-WA0015.jpg"
            alt="Cumpleaños para perros"
            className="h-full w-full object-cover object-center lg:h-full lg:w-full"
          />
        </div>

        <div
          ref={container}
          className="mx-auto max-w-2xl px-4 pt-16 pb-24 sm:px-6 sm:pb-32 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:pt-32"
        >
          <motion.div
            initial={{ x: "-100vw" }}
            animate={animation}
            className="lg:col-start-1"
          >
            <p className="mt-4 text-4xl font-bold tracking-tight text-white">
              {t("birthdayPawtieTitle")}
            </p>

            <dl className="mt-10 grid grid-cols-1 gap-y-10 gap-x-8 text-sm sm:grid-cols-2">
              {features.map((feature) => (
                <div key={feature.name}>
                  <dt className="font-medium text-white">
                    {t(feature.name)}
                    <PlusTax compact />
                  </dt>
                  <dd className="mt-2 text-gray-500">
                    {t(feature.description)}
                  </dd>
                </div>
              ))}
            </dl>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
